import { usePage } from "@inertiajs/react"
import { useEffect, useRef } from "react"
import { toast } from "sonner"

import type { FlashData } from "@/types"

function showFlash(flash: FlashData) {
  if (flash.alert) toast.error(flash.alert)
  if (flash.notice) toast(flash.notice)
}

function flashKey(flash: FlashData): string {
  return `${flash.alert ?? ""}|${flash.notice ?? ""}`
}

export function useFlash() {
  const { flash } = usePage()
  const lastKey = useRef("")

  useEffect(() => {
    const key = flashKey(flash)
    if (key !== lastKey.current && key !== "|") {
      lastKey.current = key
      showFlash(flash)
    }
  }, [flash])
}
